import service from '@/utils/server';
const modName='/mdm/mdmCompany/';
//初始化
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
//查询方法
export const companyListData = data => {
  return service({
    url: modName + 'mdmCompanyTree',
    method: 'post',
    data
  });
};

//新增方法
export const addCompany = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};
//编辑方法
export const editCompany = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};
//删除方法
export const deleteCompany = data => {
  return service({
    url: modName + 'delete',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/mdm/company/api/index.js